import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AssetType } from '../../models/asset/assetType';
import { ApiResponse } from '@card-software/nexus-utilities';
@Injectable({
  providedIn: 'root',
})
export class AssetTypeProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.assetApi + '/api/v1/type';

  public getAll(): Observable<ApiResponse<AssetType[]>> {
    return this.httpClient.get<ApiResponse<AssetType[]>>(`${this.baseUrl}/all`);
  }

  public getByCategoryId(categoryId: string): Observable<ApiResponse<AssetType[]>> {
    return this.httpClient.get<ApiResponse<AssetType[]>>(`${this.baseUrl}/category/${categoryId}`);
  }
}
